export default __webpack_public_path__ + "static/media/oscer-pres-sexual-and-menstrual-history.dab87760.svg";